import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const PediatricSurgeryIcon = React.memo(({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(height)}
    viewBox={viewBox}
  >
    <path
      fill={variables['colors-mc-primary']}
      fillOpacity='0.1'
      stroke={variables['colors-mc-primary']}
      d='M80.3569 40C80.3569 61.8153 62.6722 79.5 40.8569 79.5C19.0417 79.5 1.35693 61.8153 1.35693 40C1.35693 18.1848 19.0417 0.5 40.8569 0.5C62.6722 0.5 80.3569 18.1848 80.3569 40Z'
    />
    <g clipPath='url(#clip0_414_11247)'>
      <path
        d='M49.6803 23.8235C49.2239 23.8235 33.9599 23.8235 33.5038 23.8235L32.0332 22.3529L33.5038 20.8823H49.6803L51.1509 22.3529L49.6803 23.8235Z'
        fill='#B5DBFF'
      />
      <path
        d='M24.6804 34.1177L23.2098 35.5883L21.7393 34.1177C21.7393 32.1379 21.7393 27.9181 21.7393 26.7648L23.2098 25.2942L24.6804 26.7648L26.151 30.4412L24.6804 34.1177Z'
        fill='#D5E8FE'
      />
      <path
        d='M27.6218 34.1177L26.1513 35.5883L24.6807 34.1177C24.6807 32.1379 24.6807 27.9181 24.6807 26.7648L26.1513 25.2942L27.6218 26.7648V34.1177Z'
        fill='#B5DBFF'
      />
      <path
        d='M24.6805 26.7647C23.6129 26.7647 16.9314 26.7647 15.8569 26.7647C15.8569 25.6971 15.8569 19.0158 15.8569 17.9412H24.6805L26.1511 22.3529L24.6805 26.7647Z'
        fill='#B9DD39'
      />
      <path
        d='M33.5042 26.7647C32.4366 26.7647 25.7552 26.7647 24.6807 26.7647C24.6807 25.6971 24.6807 19.0158 24.6807 17.9412H33.5042V26.7647Z'
        fill='#90CC1C'
      />
      <path
        d='M24.6805 65.0001C24.1662 65.0001 23.7243 65.0001 23.21 65.0001C23.21 62.2277 23.21 56.3209 23.21 54.7059L23.9453 53.2354L24.6805 54.7059L26.1511 59.853L24.6805 65.0001Z'
        fill='#D5E8FE'
      />
      <path
        d='M26.1513 65.0001C25.6369 65.0001 25.195 65.0001 24.6807 65.0001C24.6807 62.2277 24.6807 56.3209 24.6807 54.7059L25.416 53.2354L26.1513 54.7059V65.0001Z'
        fill='#B5DBFF'
      />
      <path
        d='M24.6803 54.7058C23.2116 54.7058 21.7373 54.7058 20.2686 54.7058C20.2686 53.2371 20.2686 51.7628 20.2686 50.2941L22.4744 48.8235L24.6803 50.2941L26.1509 52.5L24.6803 54.7058Z'
        fill='#90CC1C'
      />
      <path
        d='M29.0924 54.7058C27.6237 54.7058 26.1494 54.7058 24.6807 54.7058C24.6807 53.2371 24.6807 51.7628 24.6807 50.2941L26.8865 48.8235L29.0924 50.2941V54.7058Z'
        fill='#00B44B'
      />
      <path
        d='M24.6806 50.2941L26.1512 45.8824L24.6806 41.4706L21.0041 40L17.3276 41.4706C17.3276 41.7712 17.3276 50.5796 17.3276 50.2941H24.6806Z'
        fill='#00964B'
      />
      <path
        d='M49.6807 17.9412V31.1765L51.1513 32.6471L52.6218 31.1765L54.0924 23.8235L52.6218 15C50.9975 15 49.6807 16.3168 49.6807 17.9412Z'
        fill='#3B6BAB'
      />
      <path
        d='M49.9 50.8026C46.6154 50.5289 43.7982 53.1209 43.7982 56.4171C43.2839 56.8473 42.842 57.217 42.3276 57.6471L47.4747 59.1177L52.6218 57.6471L54.0923 54.3382L52.6218 51.0294C51.6698 50.9501 50.8519 50.882 49.9 50.8026Z'
        fill='#FF8FC3'
      />
      <path
        d='M38.9937 56.569C37.5565 55.1319 37.5557 52.8101 38.9937 51.3721C40.4307 49.935 42.7525 49.9342 44.1906 51.3721C45.6277 52.8092 45.6285 55.1309 44.1906 56.569C42.7535 58.0061 40.4317 58.007 38.9937 56.569Z'
        fill='#FFCEBF'
      />
      <path
        d='M24.6806 41.4706C22.7008 41.4706 18.481 41.4706 17.3276 41.4706C17.3276 39.4908 17.3276 35.271 17.3276 34.1177H24.6806L26.1512 37.7941L24.6806 41.4706Z'
        fill='#B9DD39'
      />
      <path
        d='M32.0336 50.2941C30.0538 50.2941 25.834 50.2941 24.6807 50.2941C24.6807 49.8378 24.6807 34.5738 24.6807 34.1177H32.0336V50.2941Z'
        fill='#90CC1C'
      />
      <path
        d='M55.5628 17.9412C55.5628 16.3169 54.246 15 52.6216 15V31.1765L54.0922 32.6471L55.5628 31.1765C55.5628 29.5752 55.5628 19.553 55.5628 17.9412Z'
        fill='#00467D'
      />
      <path
        d='M61.6222 44.2348C61.1403 43.7531 60.5757 43.4061 59.9746 43.1935C59.9746 41.4355 59.9746 38.5837 59.9746 37.059L58.504 35.5884L57.0335 37.059V43.1936C56.4323 43.4062 55.8676 43.7532 55.3859 44.2349C54.587 45.0337 54.0923 46.1366 54.0923 47.353H57.0335C57.0335 46.542 57.6932 45.8824 58.504 45.8824C59.3149 45.8824 59.9746 46.542 59.9746 47.353H62.9158C62.9158 46.1366 62.4211 45.0337 61.6222 44.2348Z'
        fill='#B5DBFF'
      />
      <path
        d='M49.8575 42.7641C49.3972 42.3038 48.8357 41.9454 48.21 41.7234C48.21 40.127 48.21 37.582 48.21 37.0587L46.7394 35.5881L45.2688 37.0587V41.7234C43.5571 42.3305 42.3276 43.9651 42.3276 45.8823H45.2688C45.2688 45.0713 45.9285 44.4117 46.7394 44.4117C47.5503 44.4117 48.21 45.0713 48.21 45.8823H51.1512C51.1512 44.6659 50.6565 43.5629 49.8575 42.7641Z'
        fill='#D5E8FE'
      />
      <path
        d='M52.6218 37.0589C49.8494 37.0589 43.9426 37.0589 42.3276 37.0589C42.3276 36.3472 42.3276 31.8929 42.3276 31.1765H52.6218L54.0923 34.1177L52.6218 37.0589Z'
        fill='#00467D'
      />
      <path
        d='M62.9157 37.0589C60.1433 37.0589 54.2366 37.0589 52.6216 37.0589C52.6216 36.3472 52.6216 31.8929 52.6216 31.1765H62.9157V37.0589Z'
        fill='#033A5D'
      />
      <path
        d='M61.4451 55.6349C61.4451 53.4473 59.7682 51.6249 57.5882 51.4432C56.0104 51.3117 54.1994 51.1608 52.6216 51.0293V57.6469L57.0333 59.1175L61.4451 57.6469V56.6409V55.6349Z'
        fill='#FF5CA8'
      />
      <path
        d='M52.6214 64.9999C51.4779 64.9999 33.1767 64.9999 32.0332 64.9999C32.0332 63.0201 32.0332 58.8003 32.0332 57.647H52.6214L54.092 61.3234L52.6214 64.9999Z'
        fill='#C6715A'
      />
      <path
        d='M65.8569 64.9999C64.2556 64.9999 54.2334 64.9999 52.6216 64.9999C52.6216 63.0201 52.6216 58.8003 52.6216 57.647H65.8569V64.9999Z'
        fill='#B35F49'
      />
    </g>
    <defs>
      <clipPath id='clip0_414_11247'>
        <rect width='50' height='50' fill='white' transform='translate(15.8569 15)' />
      </clipPath>
    </defs>
  </svg>
));
PediatricSurgeryIcon.displayName = 'PediatricSurgeryIcon';

export default PediatricSurgeryIcon;
